import moment from 'moment/moment'
import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'
import QuestionDialog from '../components/QuestionDialog'
import { getLocations } from '../redux/locations/LocationSlice'
import { deleteCompany, getSingleCompany } from '../redux/companies/CompanySlice'
import { getUsers } from '../redux/users/userSlice'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function CompanySingle() {

    const params = useParams()
    const navigate = useNavigate()
    const [company, setCompany] = useState({})
    const dispatch = useDispatch()
    const [submitted, setSubmitted] = useState(false)
    const [showDelete, setShowDelete] = useState(false)
    const [mainPicture, setMainPicture] = useState(0)

    const companyRedux = useSelector(state => state.Company)
    const locationRedux = useSelector(state => state.Location)
    const authRedux = useSelector(state => state.Auth)

    useEffect(() => {
        if (params.id !== locationRedux.companyId) {
            dispatch( getLocations({ companyId: params.id }) )
        }
        dispatch( getUsers({ companyId: params.id , roleId: authRedux.user.claims.role }) )
    }, [params.id]) 

    useEffect(() => {
        if (submitted && !companyRedux.isButtonLoading) {
            navigate(-1)
        }   
    }, [companyRedux.isButtonLoading])

    useEffect(() => {
        if (params.id) {
            const companyInfo = companyRedux.companies.filter(company => company.id === params.id).pop()

            if (companyInfo?.id) {
                setCompany(companyInfo)
            } else {
                dispatch(getSingleCompany({ companyId: params.id }))
            }
        }
    }, [companyRedux.companies])

    const goBack = () => {
        navigate(-1)
    }

    const changeMainPictureView = (index) => {
        setMainPicture(company.pictures[index].url)
    }

    const confirmDeleteProduct = () => {
        setSubmitted(true)
        dispatch(deleteCompany({ company }))
    }


    return (
        companyRedux.isSingleLoading ? <div className="flex items-center justify-center"><div role="status">
            <svg aria-hidden="true" className="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
            </svg>
            <span className="sr-only">Loading...</span>
        </div> Loading </div> :
            <div className="bg-white">
                <QuestionDialog
                    isOpen={showDelete}
                    declineAction={() => setShowDelete(false)}
                    confirmAction={() => confirmDeleteProduct()}
                    confirmTitle={companyRedux.isButtonLoading ? 'Deleting Company...' : 'Yes, Delete it!'}
                    declineTitle="No"
                    title="Delete Company ?"
                    content="Deleting this company would also remove the logo associated to it"
                />
                <div className='flex'>
                    <button onClick={goBack} className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>

                        <span className='ml-2'>Back</span>
                    </button>
                    <button onClick={() => navigate('locations')} className="inline-flex items-center ml-2 justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                        </svg>


                        <span className='ml-2'>Manage Locations</span>
                    </button>
                    <button
                        onClick={() => navigate('products')}
                        className="inline-flex items-center justify-center ml-2 rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                        </svg>


                        <span className='ml-2'>Manage Products</span>
                    </button>
                    <button
                        onClick={() => navigate('users')}
                        className="inline-flex items-center justify-center ml-2 rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
                        </svg>



                        <span className='ml-2'>Manage Users</span>
                    </button>
                </div>

                <div className="pt-6 grid grid-cols-2">
                    {/* Image gallery */}
                    <div className="mx-auto mt-6 max-w-2xl sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-1 lg:gap-x-8 lg:px-8">
                        <div className="w-full overflow-hidden rounded-lg lg:block">
                            {
                                company && company.logo ? <img
                                    src={company.logo.url}
                                    className="h-full object-cover w-full"
                                /> : null
                            }

                        </div>
                        <div className='flex'>
                            {
                                company?.pictures?.map((picture, index) => {
                                    if (picture?.url) {
                                        return <img
                                            src={picture?.url}
                                            onClick={() => changeMainPictureView(index)}
                                            className={classNames(picture.url === mainPicture ? 'bg-slate-300' : '', "h-20 w-20 object-contain cursor-pointer hover:bg-slate-200")} />
                                    }
                                })
                            }
                        </div>
                    </div>

                    {/* Product info */}

                    <div className="mx-auto max-w-2xl w-full rounded-lg px-4 pt-10 pb-16 sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-2 lg:grid-rows-[auto,auto,1fr] lg:gap-x-8 lg:px-8 lg:pt-16 lg:pb-24">
                        <div className='w-full flex flex-row'>
                            <button onClick={() => navigate('edit')} className="inline-flex items-center justify-center rounded-md border border-transparent bg-orange-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
                                </svg>


                                <span className='ml-2'>Edit</span>
                            </button>
                            <button onClick={() => setShowDelete(true)} className="inline-flex items-center ml-2 justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                </svg>



                                <span className='ml-2'>Remove</span>
                            </button>
                        </div>

                        <div className="mt-3 lg:col-span-2 lg:pr-8">
                            <h1 className="text-2xl text-left font-bold tracking-tight text-gray-900 sm:text-3xl">{company.name}</h1>
                            <p className='text-xl text-left'> {moment.unix(company?.created_date?.seconds).format('MMMM DD, YYYY')}</p>
                        </div>
                    </div>
                </div>
            </div>
    )
}
